import { useNavigate } from 'react-router-dom';
import Icon from '../../common/Icon/Icon';
import { IconKeys } from '../../common/Icon/IconKeys';
import useDriverThumbnail from '../../../theme/useDriverThumbnail';
import ImageWithFallback from '../../common/ImageWithFallback/ImageWithFallback';
import Props from './types';
import S from './DriverRankCardStyles';

function DriversRank({
  title, score, name, since, truck, alerts, driverId, avatar,
}: Props): JSX.Element {
  let scoreModifier = '';
  if (score === null) scoreModifier = 'no-score';
  else if (score <= 20) scoreModifier = 'red';
  const scoreClassName = `score-container ${scoreModifier}`;
  const navigate = useNavigate();
  const driverThumbnail = useDriverThumbnail();

  return (
    <S.Wrapper onClick={() => driverId && navigate(`/drivers/${driverId}`)}>
      <div className="title">{title}</div>
      <div className="main-container">
        <div className="driver-details">
          <div className="driver-description">
            <div className="avatar">
              <ImageWithFallback src={avatar || driverThumbnail} alt="driver" />
            </div>
            <div className="driver-info">
              <p className="name">{name}</p>
              <p className="subtitle">{since}</p>
            </div>
          </div>
          <div className="horizontal-line" />
          <div className="tags-container">
            <div className="truck-tag">
              <Icon iconKey={IconKeys.TRUCK} />
              <p>{truck}</p>
            </div>
            <div className="alert-tag">
              <Icon iconKey={IconKeys.ALERT} />
              <p>{alerts}</p>
            </div>
          </div>
        </div>
        <div className={scoreClassName}>{score ?? 'N/A'}</div>
      </div>
    </S.Wrapper>
  );
}

export default DriversRank;
